/**
 * The top-centre status banners — blocked audio, "Connection unstable…", and the SC-255 zoom
 * notice — read as one family, so the chrome they share lives here instead of being copied per
 * component. Hand-maintained copies had already drifted apart on shadow.
 *
 * Sequence lives in `utils/statusBannerStack`; the column they render into is
 * `components/StatusBannerViewport`.
 */
export const statusBannerAlertSx = {
  borderRadius: '8px',
  // Theme elevation, not a literal rgba: this is product chrome, and per AGENTS.md its colours
  // come from the workspace theme rather than an ad hoc value that cannot follow it.
  boxShadow: 4,
  alignItems: 'center',
  // The column is click-through so it never blocks the game canvas; each banner opts back in.
  pointerEvents: 'auto',
  '& .MuiAlert-icon': {
    fontSize: '1.25rem',
  },
}

/** Distance from the top of the visible viewport to the topmost banner. */
export const STATUS_BANNER_TOP_MARGIN_PX = 16

/** Space left between two stacked banners. */
export const STATUS_BANNER_GAP_PX = 8

/**
 * One z-index for the whole column, because siblings in a flex column cannot overlap and so have
 * nothing to resolve between them.
 *
 * The value is the one SC-257 gave the audio-resume prompt. That banner is the only one the user
 * must *click* to recover, so it must never end up behind anything; sharing its z-index extends
 * that guarantee to the column without raising anyone above the chat panel.
 */
export const STATUS_BANNER_Z_INDEX = 100000
